<app-select
  [options]="languages()"
  [selectedOption]="activeLang"
  (selectionChange)="setActiveLang($event)"
  icon="language"
></app-select>
